
        import React from 'react';
        import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new SpriteSymbol({
  "id": "drop.sprite",
  "use": "drop.sprite-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"drop.sprite\">\n <polygon points=\"12 17 18 11 16.59 9.59 12 14.17 7.41 9.59 6 11\" fill-rule=\"evenodd\" />\n</symbol>"
});
        sprite.add(symbol);

        const DropSpriteSpriteSymbol = props => (
            <svg {...props} viewBox='0 0 24 24'>
                <use xlinkHref='#drop.sprite' />
            </svg>
        );
        export default DropSpriteSpriteSymbol;
  